var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDamosCredito(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.333 44.333c0-.793.094-1.563.21-2.333H7V28h37.333v2.333c1.634 0 3.197.304 4.667.817V14a4.65 4.65 0 00-4.667-4.667H7A4.65 4.65 0 002.333 14v28A4.665 4.665 0 007 46.667h23.543c-.116-.77-.21-1.54-.21-2.334zM7 14h37.333v4.667H7V14zm34.417 37.333l-6.417-7 2.707-2.706 3.71 3.71 8.376-8.377 2.707 3.29-11.083 11.083z",
    fill: "#54DCF2"
  })));
}
export default SvgIconDamosCredito;